export default __webpack_public_path__ + "images/5dd81f6cb61c05f321f18eee3a69d3e3-childrenandyouth_small.webp";